import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const SalesChart = () => {
  const salesData = [
    { month: 'Ene', ventas: 45000, presupuestos: 52000 },
    { month: 'Feb', ventas: 52000, presupuestos: 61000 },
    { month: 'Mar', ventas: 48000, presupuestos: 55000 },
    { month: 'Abr', ventas: 61000, presupuestos: 67000 },
    { month: 'May', ventas: 55000, presupuestos: 62000 },
    { month: 'Jun', ventas: 67000, presupuestos: 74000 },
    { month: 'Jul', ventas: 72000, presupuestos: 78000 },
    { month: 'Ago', ventas: 69000, presupuestos: 75000 },
    { month: 'Sep', ventas: 76000, presupuestos: 82000 },
    { month: 'Oct', ventas: 82000, presupuestos: 89000 },
    { month: 'Nov', ventas: 79000, presupuestos: 85000 },
    { month: 'Dic', ventas: 85000, presupuestos: 92000 }
  ];

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-surface border border-border rounded-lg p-3 shadow-modal">
          <p className="text-sm font-body-medium text-text-primary mb-2">{label}</p>
          {payload.map((entry, index) => (
            <p key={index} className="text-sm" style={{ color: entry.color }}>
              {entry.name}: {formatCurrency(entry.value)}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-heading-semibold text-text-primary">
          Tendencia de Ventas
        </h2>
        <div className="flex items-center space-x-4 text-sm">
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 bg-primary rounded-full"></div>
            <span className="text-text-secondary">Ventas</span>
          </div>
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 bg-success rounded-full"></div>
            <span className="text-text-secondary">Presupuestos</span>
          </div>
        </div>
      </div>

      <div className="w-full h-80" aria-label="Gráfico de tendencia de ventas">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={salesData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="month" 
              stroke="var(--color-text-muted)"
              fontSize={12}
            />
            <YAxis 
              stroke="var(--color-text-muted)"
              fontSize={12}
              tickFormatter={formatCurrency}
            />
            <Tooltip content={<CustomTooltip />} />
            <Line 
              type="monotone" 
              dataKey="ventas" 
              stroke="var(--color-primary)" 
              strokeWidth={3}
              dot={{ fill: 'var(--color-primary)', strokeWidth: 2, r: 4 }}
              activeDot={{ r: 6, stroke: 'var(--color-primary)', strokeWidth: 2 }}
              name="Ventas"
            />
            <Line 
              type="monotone" 
              dataKey="presupuestos" 
              stroke="var(--color-success)" 
              strokeWidth={3}
              dot={{ fill: 'var(--color-success)', strokeWidth: 2, r: 4 }}
              activeDot={{ r: 6, stroke: 'var(--color-success)', strokeWidth: 2 }}
              name="Presupuestos"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default SalesChart;